import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const globalSettingsIssueWorkflowSchemesRoute: InvariantRoute = {
	name: 'global-settings-issues-workflows-schemes-view',
	path: '/secure/admin/ViewWorkflowSchemes.jspa',
};
